module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-6-a474e592f0520bf571d8fb597fa46d2f.png";